import React, { useEffect, useRef, useState } from 'react'
import { gifts, ratingScrollbarSettings } from '../../../constants/copyright'
import { safeHTML } from '../../../utils/safeHTML'
import Scrollbar from 'react-scrollbars-custom'
import { useUser } from '../../../redux/reducer/user'
import { image } from '../../../utils/data/baseUrl'
import classNames from 'classnames'
import { useRequests } from '../../../redux/reducer/requests'
import { useModal } from '../../../hooks/useModal'
import { useLevelData } from '../../../hooks/useLevelData'
import { useGoldenAppleUrl } from '../../../hooks/useGoldenAppleUrl'
import Back from '../../features/back/Back'
import useStateControls from '../../../hooks/useStateControls'
import { useTranslation } from '../../../translations'

const Roadmap = React.forwardRef(function Roadmap({ callbacks }, ref) {
  const { modalButtons, modalLink } = gifts
  const {
    authData: { isWeb },
  } = useRequests()
  const {
    profile: { prizes: prizesList, score },
  } = useUser()
  const { addModal } = useModal()
  const { level, levels } = useLevelData()
  const currentLevelRef = useRef()
  const scrollbarRef = useRef()
  const currentCheckRef = useRef()
  const nextCheckRef = useRef()
  const lastCheckRef = useRef()
  const containerRef = useRef()
  const { setState } = useStateControls()
  const { t } = useTranslation()
  const goldenAppleUrl = useGoldenAppleUrl()

  const [lineHeight, setLineHeight] = useState(0)

  const openPrizeModal = (score) => {
    const prize = prizesList.find(({ required_score }) => required_score === score)

    prize &&
      addModal({
        type: 'winModal',
        props: {
          ...prize,
          img: prize.image,
          buttons: modalButtons,
          noXP: true,
          link: modalLink,
          linkBtn: goldenAppleUrl,
        },
      })
  }

  useEffect(() => {
    if (!scrollbarRef.current) return

    if (!currentLevelRef.current) {
      scrollbarRef?.current?.scrollTo?.(0, scrollbarRef?.current?.scrollHeight)
      return
    }

    const target = currentLevelRef.current.offsetTop - scrollbarRef.current.clientHeight / 3

    scrollbarRef.current.scrollTo(0, target)
  }, [currentLevelRef.current, scrollbarRef.current])

  useEffect(() => {
    if (
      typeof level !== 'number' ||
      !Array.isArray(levels) ||
      ![lastCheckRef?.current, nextCheckRef?.current, currentCheckRef?.current].every(Boolean)
    )
      return setLineHeight(0)

    const intervalCallback = () => {
      if (!currentCheckRef.current) return

      const currentRect = currentCheckRef.current.getBoundingClientRect() //todo: решить проблему иначе
      const nextRect = nextCheckRef.current.getBoundingClientRect()
      const lastRect = lastCheckRef.current.getBoundingClientRect()

      const betweenNextCurrentPx = currentRect.bottom - nextRect.bottom

      const betweenNextCurrentProportion = (() => {
        const { currentLevel, nextLevel } = levels?.reduce((acc, levelData) => {
          const key =
            levelData?.number === level
              ? 'currentLevel'
              : levelData?.number - level === 1 && 'nextLevel'
          return !key ? acc : { ...acc, [key]: levelData }
        }, {})

        return (
          (score - currentLevel?.required_score) /
          (nextLevel?.required_score - currentLevel?.required_score)
        )
      })()

      const totalHeight =
        betweenNextCurrentProportion * betweenNextCurrentPx +
        (lastRect.top - currentRect.top) +
        currentRect.height / 2

      setLineHeight(Math.min(containerRef?.current?.scrollHeight, totalHeight))
    }

    const interval = setInterval(intervalCallback, 1000)
    return () => clearInterval(interval)
  }, [level, levels, score, currentCheckRef.current, nextCheckRef.current, lastCheckRef.current])

  return (
    <section
      className={`roadmap ${isWeb ? '' : 'app'}`}
      ref={ref}
    >
      <Back onClick={() => setState('main')} />
      <div className='roadmap__content'>
        <Scrollbar
          {...ratingScrollbarSettings}
          ref={scrollbarRef}
        >
          <div
            className={'roadmap__list'}
            ref={containerRef}
          >
            {[...levels]
              .reverse()
              .map(({ title, number, required_score, description, icon }, i, arr) => {
                return (
                  <div
                    className={classNames('roadmap__item', {
                      roadmap__item_active: level >= number,
                    })}
                    onClick={() => openPrizeModal(required_score)}
                    key={`level-${i}`}
                    {...(level === number ? { ref: currentLevelRef } : {})}
                  >
                    <div className={'roadmap__item-block'}>
                      <div className={'roadmap__item-title'}>
                        {safeHTML(t('other.levelWithValue', { value: number }))}
                      </div>
                      <div className={'roadmap__item-points'}>
                        {safeHTML(required_score)}
                        {' XP'}
                      </div>
                      <div className={'roadmap__item-text'}>{safeHTML(description)}</div>
                    </div>
                    {icon && (
                      <div className={'roadmap__item-image'}>
                        <img
                          src={icon}
                          alt={title}
                        />
                      </div>
                    )}
                    <div
                      className={'roadmap__item-state'}
                      {...(level === number && { ref: currentCheckRef })}
                      {...(number - level === 1 && { ref: nextCheckRef })}
                      {...(arr.length - 1 === i && { ref: lastCheckRef })}
                    >
                      {number <= level && (
                        <img
                          src={image('ok.svg')}
                          alt={'ok'}
                        />
                      )}
                    </div>
                  </div>
                )
              })}
            <div className={'roadmap__line'}>
              <div className={'roadmap__line-container'}>
                <div
                  className={'roadmap__line-block'}
                  style={{ height: lineHeight }}
                />
              </div>
            </div>
          </div>
        </Scrollbar>
      </div>
    </section>
  )
})
export default Roadmap
Roadmap.propTypes = {}
